import { NgModule } from '@angular/core';

import { ModalComponent } from './modal.component';

@NgModule({
    declarations: [ModalComponent],
    exports: [ModalComponent]
})
export class ModalModule {}
